import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const MODES = [
  { value: "statement", label: "Statement of Accounts" },
  { value: "checklist", label: "Checklist" },
];

const PRODUCTS = [
  { key: "mutual_fund", label: "Mutual Fund" },
  { key: "share_bond", label: "Share & Bond" },
  { key: "fixed_deposit", label: "Fixed Deposit" },
  { key: "other_assets", label: "Other Assets" },
];

const VIEW_TYPES = [
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function TransactionReport() {
  const [mode, setMode] = useState("checklist");
  const [products, setProducts] = useState(() =>
    PRODUCTS.reduce((acc, p) => ({ ...acc, [p.key]: true }), {})
  );
  const [investor, setInvestor] = useState("all_selected");
  const [dateFrom, setDateFrom] = useState("2026-01-10");
  const [dateTo, setDateTo] = useState("2026-02-10");
  const [folio, setFolio] = useState("all_selected");
  const [viewType, setViewType] = useState("pdf");
  const [applying, setApplying] = useState(false);

  const toggleProduct = (key) => {
    setProducts((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: generate report (PDF/Excel) based on filters
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Transaction Report</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/transaction-report">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Transaction Report</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          {/* Mode */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Mode:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {MODES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="mode"
                    value={opt.value}
                    checked={mode === opt.value}
                    onChange={() => setMode(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Choose Products */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Choose Products:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {PRODUCTS.map((p) => (
                <label key={p.key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={products[p.key]}
                    onChange={() => toggleProduct(p.key)}
                    style={{ accentColor: TEAL, width: 16, height: 16 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{p.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Filters: Investor, Date, Folio */}
          <div className="mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label small text-muted">Investor :</label>
                <select
                  className="form-select form-select-sm"
                  value={investor}
                  onChange={(e) => setInvestor(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="all_selected">All Selected</option>
                  <option value="primary">Primary</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Date:</label>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-group input-group-sm">
            
                    <input
                      type="date"
                      className="form-control"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                      style={inputBorderStyle}
                    />
                  </div>
                  <span className="text-muted">-</span>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    style={{ ...inputBorderStyle }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Folio :</label>
                <select
                  className="form-select form-select-sm"
                  value={folio}
                  onChange={(e) => setFolio(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="all_selected">All Selected</option>
                </select>
              </div>
            </div>
          </div>

          {/* View Type */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              View Type:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {VIEW_TYPES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="viewType"
                    value={opt.value}
                    checked={viewType === opt.value}
                    onChange={() => setViewType(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Apply */}
          <div className="d-flex justify-content-center pt-2">
            <button
              type="button"
              className="btn px-5 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "15px",
              }}
              onClick={handleApply}
              disabled={applying}
            >
              {applying ? "Applying…" : "Apply"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
